import { InsightsPage } from '@/components/insights/InsightsPage';
import { createFileRoute } from '@tanstack/react-router';

export type InsightsSearchParams = {
  launchBulkCategorize?: boolean;
};

export const Route = createFileRoute('/dashboard/insights/')({
  component: InsightsPage,
  validateSearch: (search: Record<string, unknown>): InsightsSearchParams => {
    return {
      launchBulkCategorize:
        search.launchBulkCategorize === 'true' ||
        search.launchBulkCategorize === true,
    };
  },
});
